<script setup>
import { ref, watch, defineProps, defineEmits } from "vue"

const props = defineProps({
  modelValue: { type: Object, required: true },
  loading: { type: Boolean, default: false }
})

const emit = defineEmits(["update:modelValue", "save", "cancel"])

const localForm = ref({ ...props.modelValue })
const isFormValid = ref(false) // <-- validity tracking

watch(
    () => props.modelValue,
    (newVal) => {
      if (JSON.stringify(newVal) !== JSON.stringify(localForm.value)) {
        localForm.value = { ...newVal }
      }
    },
    { deep: true }
)

const formRef = ref(null)

const requiredRule = (v) => !!v || "This field is required"

function submitForm() {
  if (formRef.value.validate()) {
    emit("save", localForm.value)
  }
}
</script>

<template>
  <v-form ref="formRef" v-model="isFormValid">
    <v-text-field
        v-model="localForm.operatorProfileId"
        label="Operator Profile ID"
        :rules="[requiredRule]"
        :disabled="props.loading"
        required
    />
    <v-text-field
        v-model="localForm.username"
        label="Username"
        :rules="[requiredRule]"
        :disabled="props.loading"
        required
    />
    <v-text-field
        v-model="localForm.password"
        type="password"
        label="Password"
        :rules="[requiredRule]"
        :disabled="props.loading"
        required
    />
    <v-select
        v-model="localForm.role"
        :items="['Admin', 'OCC', 'LSB', 'Depot']"
        label="Role"
        :rules="[requiredRule]"
        :disabled="props.loading"
        required
    />

    <v-divider class="my-3" />

    <div class="d-flex justify-end">
      <v-btn variant="plain" @click="emit('cancel')" :disabled="props.loading">Close</v-btn>
      <v-btn
          class="ml-2"
          color="primary"
          variant="tonal"
          :disabled="props.loading || !isFormValid"
          @click="submitForm"
      >
        <span v-if="props.loading">Saving...</span>
        <span v-else>Register</span>
      </v-btn>
    </div>
  </v-form>
</template>
